module.exports = __webpack_public_path__ + "img/event2502_2_7.d83df1a3.jpg";